export function getYDoc(state) {
  return state.collab.yDoc;
}
export function getUndoManager(state) {
  return state.collab.undoManager;
}
//# sourceMappingURL=selectors.js.map